<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer001">
<h1 class="Prelims-head">About the Author</h1>
<p class="Prelims-main">Jacquie Large (TOOT) loves poems, stories, and anything that will make you smile. Her poems, especially, are about her take on life, the fun and drama along the way.</p>
<p class="Prelims-main">Her poems have sometimes made it into her local paper <em class="italic _idGenCharOverride-1">The Border Post</em>, and last year she ran a poetry class at her local art gallery.</p>
<p class="Prelims-main">Her poems are fun, light-hearted and tricky. Some of them have happened to her and this makes them special!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398418653_EPUB.vue?698f14b4